import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path
      d="M20,33.719c-7.564,0-13.719-6.154-13.719-13.719S12.436,6.281,20,6.281S33.719,12.436,33.719,20S27.564,33.719,20,33.719z
	 M20,8.281C13.538,8.281,8.281,13.538,8.281,20S13.538,31.719,20,31.719S31.719,26.462,31.719,20S26.462,8.281,20,8.281z"
    />
    <path
      d="M20,20.862c-2.916,0-5.287-2.372-5.287-5.288s2.372-5.288,5.287-5.288s5.288,2.372,5.288,5.288S22.915,20.862,20,20.862z
	 M20,12.287c-1.813,0-3.287,1.475-3.287,3.288s1.475,3.288,3.287,3.288c1.813,0,3.288-1.475,3.288-3.288S21.813,12.287,20,12.287z"
    />
    <path
      d="M9.383,27.446l-1.571-1.237c0.148-0.19,3.736-4.646,12.188-4.646s12.042,4.456,12.19,4.646l-1.574,1.234
	c-0.124-0.154-3.195-3.88-10.616-3.88C12.58,23.563,9.51,27.287,9.383,27.446z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Contact.jsx